import { Avatar as t, AvatarBadge as e, AvatarFallback as v, AvatarImage as s, AvatarShapes as A, AvatarSizes as i, avatarShapeVariants as g, badgeVariants as p } from "./Avatar.js";
export {
  t as Avatar,
  e as AvatarBadge,
  v as AvatarFallback,
  s as AvatarImage,
  A as AvatarShapes,
  i as AvatarSizes,
  g as avatarShapeVariants,
  p as badgeVariants
};
